export default {
  buttons: {
    title1: 'Recadrer',
    title2: 'Fermer',
  },
};
